import { IconComponent } from '../icon.types';

export const CancelIcon: IconComponent = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18 7.80242L13.8024 12L18 16.1976L16.1976 18L12 13.8024L7.80242 18L6 16.1976L10.1976 12L6 7.80242L7.80242 6L12 10.1976L16.1976 6L18 7.80242Z"
      fill="currentColor"
    />
  </svg>
);
